import {createInitialSearchPageState} from './duck/search-reducer';

/**
 * Different types of search.
 */
export enum SearchPageType {
    BASIC = 'BASIC',
}

export type Routing = {
    endpoint: string; // declare with leading slash
    route: string; // frontend route, for example 'search' will result in '/search/query?...'
};

export type SearchPageAttributes = Record<SearchPageType, Routing>;

export const searchPageAttributesMap: SearchPageAttributes = {
    [SearchPageType.BASIC]: {
        endpoint: '',
        route: 'search',
    },
};

export const createInitialSearchState = (): any => ({
    [SearchPageType.BASIC]: createInitialSearchPageState(),
});
